var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4085 0.483398H1.89613C1.21031 0.483398 0.652344 1.02117 0.652344 1.68221V3.09306C0.652344 3.7541 1.21031 4.29191 1.89613 4.29191H2.47843L8.90643 10.4876V15.9115C8.90643 16.0731 9.00744 16.2188 9.16237 16.2807C9.21366 16.3011 9.26752 16.3111 9.32092 16.3111C9.42885 16.3111 9.5349 16.2705 9.6142 16.1941L12.2923 13.6127C12.37 13.5378 12.4137 13.4361 12.4137 13.3301V10.4876L18.8416 4.29191H19.4086C20.0944 4.29191 20.6523 3.7541 20.6523 3.09306V1.68221C20.6523 1.02117 20.0943 0.483398 19.4085 0.483398ZM11.7058 10.0396C11.6239 10.1186 11.5836 10.2222 11.5845 10.3257V13.1647L9.73561 14.9468V10.3233C9.73588 10.2207 9.69549 10.1179 9.61424 10.0396L3.65109 4.29191H17.6689L11.7058 10.0396ZM19.8231 3.09306C19.8231 3.3134 19.6372 3.49269 19.4085 3.49269H1.89613C1.66754 3.49269 1.48152 3.31344 1.48152 3.09306V1.68221C1.48152 1.46187 1.6675 1.28258 1.89613 1.28258H19.4086C19.6372 1.28258 19.8232 1.46183 19.8232 1.68221L19.8231 3.09306Z",
    fill: "url(#paint0_linear_9_2252)",
    stroke: "url(#paint1_linear_9_2252)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_2252",
    x1: 10.6523,
    y1: 0.483398,
    x2: 10.6523,
    y2: 16.3111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D172A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_2252",
    x1: 10.6523,
    y1: 0.483398,
    x2: 10.6523,
    y2: 16.3111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D172A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.b97f26adf0bf6456224e10d1177f1cdb.svg";
export { ForwardRef as ReactComponent };